var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { RadioFilter } from "@irati/ui/src/FormItem";
import { injectIntl } from "@irati/utils/lang";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 20px;\n"])));
var Title = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
export var BalanceSort;
(function (BalanceSort) {
    BalanceSort["low"] = "low";
    BalanceSort["high"] = "high";
})(BalanceSort || (BalanceSort = {}));
var RemainingBalanceHeader = /** @class */ (function (_super) {
    __extends(RemainingBalanceHeader, _super);
    function RemainingBalanceHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            balanceSort: BalanceSort.high
        };
        _this.handleFilter = function (balanceSort) {
            _this.setState({ balanceSort: balanceSort });
            _this.props.onChange(balanceSort);
        };
        return _this;
    }
    RemainingBalanceHeader.prototype.render = function () {
        var idNamespace = "WalletDateHeader";
        var balanceSort = this.state.balanceSort;
        var formatMessage = this.props.formatMessage;
        var options = [
            { value: BalanceSort.high, label: formatMessage({ id: "admin.reportingV2.wallet.columns.balance.labels.highToLow" }) },
            { value: BalanceSort.low, label: formatMessage({ id: "admin.reportingV2.wallet.columns.balance.labels.lowToHigh" }) }
        ];
        return (React.createElement(Wrapper, { id: idNamespace },
            React.createElement(Title, null, formatMessage({ id: "admin.reportingV2.wallet.columns.balance.title" })),
            React.createElement(RadioFilter, { icon: "sort", hideFooter: true, options: options, value: balanceSort, onChange: this.handleFilter, shouldFillIcon: function () { return false; } })));
    };
    return RemainingBalanceHeader;
}(Component));
export default injectIntl(RemainingBalanceHeader);
var templateObject_1, templateObject_2;
